<template>
  <div class="sub-retailer-header">
    <h6>Agent</h6>
    <div class="row">
      <div class="col-lg-4 col-md-12 col-12 align-items-center">
        <div class="row">
          <div class="col">
            <div class="input-group">
              <span class="input-group-text text-body">
                <i class="fas fa-search" aria-hidden="true"></i>
              </span>
              <input type="text" class="form-control" placeholder="Search Sub Retailer Users" onfocus="focused(this)"
                onfocusout="defocused(this)" v-model="filter.keyword" @keyup="filterSubRetailersUser" :disabled="loading" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-md-12 col-12 d-flex justify-content-end align-items-center">
        <div class="icon-container-action text-dark d-flex align-items-center d-none" @click="notImplemented"
          style="font-size: 13px">
          <img src="/img/top-up.png" class="me-1" alt="logo" /> Top Up Dealer
          Balance
        </div>
        <div class="icon-container-action text-dark d-flex align-items-center d-none" @click="notImplemented"
          style="font-size: 13px">
          <img src="/img/transfercredittowallet.png" class="me-1" alt="logo" /> Transfer Rebate To Wallet
        </div>
        <button class="btn bg-gradient-dark mb-0 ms-3" @click="showSubRetailerUserDetail">
          <i class="fas fa-plus me-1"></i>
          Add Sub Retailer Users
        </button>

      </div>
    </div>
  </div>
  <subRetailerUserDetail />
</template>

<script>
import { mapMutations, mapState } from "vuex";
import subRetailerUserDetail from "./../../subRetailersView/components/subRetailerUserDetail.vue"

export default {
  components: {
    subRetailerUserDetail,
  },
  computed: {
    ...mapState({
      filter: (state) => state.retailerController.subRetailerUserFilter,
    }),
  },
  methods: {
    ...mapMutations({
      selectSubRetailerUser: "retailerController/SELECT_SubRetailerUser",
      setShowSubRetailerUserDetailSidebar:
        "retailerController/SET_ShowSubRetailerUserDetailSidebar",
      filterSubRetailersUser: "retailerController/FILTER_SubRetailersUser",
    }),
    showSubRetailerDetail() {
      this.selectSubRetailer(null);
      this.setShowSubRetailerSidebar(true);
    },
    showSubRetailerUserDetail() {
      this.selectSubRetailerUser(null);
      this.setShowSubRetailerUserDetailSidebar(true);
    },
    notImplemented() {
      alert("not yet implemented.");
    },
  },
};
</script>

<style></style>
